import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import { loadRuntimeConfig } from "@/core/runtimeConfig";
import { setupAuthGuard } from "@/router/guards";
import { isLoggedIn } from "@/core/auth/token";

const app = createApp(App);

import defineDirective from "@/utils/directives";

import ElementPlus from "element-plus";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "./assets/styles/element/index.scss";
import "element-plus/theme-chalk/display.css";
app.use(ElementPlus, { locale: zhCn });

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

import "./assets/styles/reset.scss";
import "./assets/styles/knowledge/index.scss";
import "./assets/styles/iconfont.scss";

function showBootstrapError(message) {
  const root = document.getElementById("app");
  if (root) {
    root.innerHTML = `<div style="padding:24px;color:#c45656;">${message}</div>`;
  }
}

loadRuntimeConfig()
  .then(async () => {
    const { default: router } = await import("@/router");
    setupAuthGuard(router, store);

    router.afterEach(() => {
      if (isLoggedIn()) {
        store.dispatch("permission/fetchPermission");
      }
    });

    app.use(store).use(router).use(defineDirective).mount("#app");
  })
  .catch((err) => {
    console.error(err);
    showBootstrapError("配置加载失败，请刷新页面或联系管理员。");
  });
